export interface Testimonial {
  initials: string
  name: string
  role: string
  location: string
  text: string
}

export const shortTestimonials: Testimonial[] = [
  {
    initials: 'DH',
    name: 'Daniel Harper',
    role: 'Taekwondo Instructor',
    location: 'Denver, USA',
    text: 'I used to spend hours planning every week. Now I open the system, choose the objective and I already have a complete class structure ready to teach. It has made my planning much faster and more consistent.',
  },
  {
    initials: 'LM',
    name: 'Laura Mendes',
    role: 'Taekwondo Coach',
    location: 'Porto, Portugal',
    text: 'The visual progressions are one of the strongest parts of the system. My students understand kicking mechanics and technical corrections much faster when I can show them the movement step by step.',
  },
  {
    initials: 'TR',
    name: 'Tom Richardson',
    role: 'Taekwondo Instructor',
    location: 'Manchester, UK',
    text: 'The ready-to-teach sessions give me much more structure. I no longer feel like I am repeating random drills every week, and I can see a clearer progression from one class to the next.',
  },
]
